import React from 'react';

const Notification = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18286 19.533C4.89953 19.533 4.66203 19.4371 4.47036 19.2455C4.27869 19.0538 4.18286 18.8163 4.18286 18.533C4.18286 18.2496 4.27869 18.0121 4.47036 17.8205C4.66203 17.6288 4.89953 17.533 5.18286 17.533H6.18286V10.533C6.18286 9.14963 6.59953 7.92046 7.43286 6.84546C8.26619 5.77046 9.34953 5.06629 10.6829 4.73296V4.03296C10.6829 3.61629 10.8287 3.26213 11.1204 2.97046C11.412 2.67879 11.7662 2.53296 12.1829 2.53296C12.5995 2.53296 12.9537 2.67879 13.2454 2.97046C13.537 3.26213 13.6829 3.61629 13.6829 4.03296V4.73296C15.0162 5.06629 16.0995 5.77046 16.9329 6.84546C17.7662 7.92046 18.1829 9.14963 18.1829 10.533V17.533H19.1829C19.4662 17.533 19.7037 17.6288 19.8954 17.8205C20.087 18.0121 20.1829 18.2496 20.1829 18.533C20.1829 18.8163 20.087 19.0538 19.8954 19.2455C19.7037 19.4371 19.4662 19.533 19.1829 19.533H5.18286ZM12.1829 22.533C11.6329 22.533 11.162 22.3371 10.7704 21.9455C10.3787 21.5538 10.1829 21.083 10.1829 20.533H14.1829C14.1829 21.083 13.987 21.5538 13.5954 21.9455C13.2037 22.3371 12.7329 22.533 12.1829 22.533ZM8.18286 17.533H16.1829V10.533C16.1829 9.43296 15.7912 8.49129 15.0079 7.70796C14.2245 6.92463 13.2829 6.53296 12.1829 6.53296C11.0829 6.53296 10.1412 6.92463 9.35786 7.70796C8.57453 8.49129 8.18286 9.43296 8.18286 10.533V17.533Z"
        fill="#404750"
      />
    </svg>
  );
};

export default Notification;
